var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"patient-ai-summarize",class:{ small: _vm.small },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"fas fa-hat-wizard"}),_c('span',[_vm._v("Summarize")])])}
var staticRenderFns = []

export { render, staticRenderFns }